import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import ProductCategoryTabAtm from "../../atoms/ProductCategoryTabAtm/ProductCategoryTabAtm";
export var TabsWrapper = styled.div.withConfig({
  componentId: "sc-6xbfh0-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;flex-direction:row;align-items:center;gap:12px;justify-content:space-between;padding:0 0 ", ";border-radius:", ";", "{padding:0 ", " ", ";}"], space(1), getBorderRadius(theme, "large"), breakpoint("small", "large"), space(2), space(1));
});
export var PointerWrapper = styled.div.withConfig({
  componentId: "sc-6xbfh0-1"
})(function (_ref2) {
  var $position = _ref2.$position;
  return css(["height:", ";margin-left:", "px;transition:all 0.1s;", "{height:", ";}"], space(2), $position, breakpoint("small", "medium"), space(1.5));
});
export var Separator = styled.div.withConfig({
  componentId: "sc-6xbfh0-2"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["width:", ";height:", ";margin:0 ", ";background-color:", ";display:block;", "{display:none;}"], unit(1), space(3), space(1.5), getBorderColor(theme, "customDark", "low"), breakpoint("small", "medium"));
});
export var MobileTextContainer = styled.div.withConfig({
  componentId: "sc-6xbfh0-3"
})(function (_ref4) {
  var theme = _ref4.theme;
  return css(["border-radius:", " ", " 0 0;display:none;align-items:center;justify-content:center;background-color:", ";padding:", " 0;gap:", ";", "{display:flex;}"], space(3), space(3), getColor(theme, "white"), space(2), space(1), breakpoint("small", "medium"));
});
export var StyledProductCategoryTab = styled(ProductCategoryTabAtm).withConfig({
  componentId: "sc-6xbfh0-4"
})(function () {
  return css(["", "{&:first-child{display:none;}}"], breakpoint("small", "medium"));
});